import React, { useMemo, useState } from 'react'
import { Button, Grid, PageHeader, PageSection } from '@superhi/design'

import Page from '../../components/Page'
import LibraryPostArticleCard from '../../components/LibraryPostArticleCard'
import LibraryPostVideoCard from '../../components/LibraryPostVideoCard'
import { PageConfig } from '../../routing/types'

import { Props } from './data'
import ROUTE from './route'

const VS_1 = { small: 32, medium: 40, large: 56, xlarge: 56 }
const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 4,
}
const PER_PAGE = 12

const Tutorials: PageConfig<Props> = ({ posts = [] }) => {
  const [offset, setOffset] = useState(1)

  const totalPostsNum = posts.length
  const filteredPosts = useMemo(() => posts.slice(0, PER_PAGE * offset), [posts, offset])
  const filteredPostsNum = filteredPosts.length
  const hasMorePosts = filteredPostsNum < totalPostsNum
  const showMore = () => setOffset((currentOffset) => currentOffset + 1)

  return (
    <Page
      title="Tutorials"
      description="Resources and advice on how to make, build, learn and grow your creative career."
      key="tutorials"
    >
      <PageHeader backgroundVersion="BLUE_03" title="Tutorials" compact />

      <PageSection footer={hasMorePosts && <Button onClick={showMore}>See more</Button>}>
        <Grid rowGap={VS_1}>
          {filteredPosts?.map((post): React.ReactElement => {
            switch (post.__typename) {
              case 'LibraryPostArticle': {
                return (
                  <Grid.Cell key={post.slug} span={GRID_1_CELL_SPAN_1}>
                    <LibraryPostArticleCard {...post} headingLevel="2" noType imageLazy />
                  </Grid.Cell>
                )
              }
              case 'LibraryPostVideo': {
                return (
                  <Grid.Cell key={post.slug} span={GRID_1_CELL_SPAN_1}>
                    <LibraryPostVideoCard {...post} headingLevel="2" noType imageLazy />
                  </Grid.Cell>
                )
              }
            }
          })}
        </Grid>
      </PageSection>
    </Page>
  )
}

Tutorials.route = ROUTE

export { getStaticProps } from './data'
export default Tutorials
